
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34832',
  depVersions: {
  "documents-public-ui": "static-1.34832",
  "atom": "static-1.5208",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2630",
  "client-types": "static-1.484",
  "cssUtils": "static-1.831",
  "customer-data-filters-ui": "static-1.40256",
  "customer-data-objects": "static-1.7811",
  "customer-data-property-utils": "static-1.8227",
  "documents-lib": "static-1.34837",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.348",
  "FormsCommonComponents": "static-1.86171",
  "FormUrlGenerator": "static-2.4854",
  "foundations-theming-specialty": "static-1.2280",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5726",
  "hs-test-utils": "static-1.8152",
  "hub-http": "static-1.6354",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11910",
  "HubStyleTokens": "static-2.11603",
  "I18n": "static-7.1641",
  "icons": "static-2.656",
  "jasmine-immutable": "static-1.3154",
  "jasmine-runner": "static-1.6590",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7284",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5529",
  "quartz": "static-1.7207",
  "react": "static-7.187",
  "react-dlb": "static-1.81",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16817",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5441",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8308",
  "reference-resolvers-lite": "static-1.8228",
  "reporting-data": "static-1.68090",
  "reporting-reports": "static-1.67768",
  "reporting-snowflake": "static-1.56708",
  "reporting-testing-lib": "static-1.10023",
  "reporting-visualizations": "static-1.60166",
  "reselect": "static-3.6",
  "sales-content-partitioning": "static-1.9080",
  "sanitize": "static-1.4609",
  "sanitize-text": "static-1.8279",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1877",
  "signup-constants": "static-1.19184",
  "signup-ui-url-generator": "static-2.8190",
  "StyleGuideUI": "static-3.489",
  "superstore": "static-1.4892",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4892",
  "ui-addon-form-validation": "static-1.11123",
  "ui-asset-management-lib": "static-1.11207",
  "ui-images": "static-2.1189",
  "UIComponents": "static-3.8549",
  "usage-tracker": "static-1.7483",
  "usage-tracker-container": "static-1.7473",
  "usage-tracker-core": "static-1.7333",
  "viral-links-lib": "static-1.7202",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9793",
  "foundations-components": "static-1.8194",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.985",
  "quartz-core": "static-1.6426",
  "quick-fetch": "static-1.4017",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4789",
  "ui-addon-i18n": "static-1.11281",
  "ui-addon-upgrades": "static-9.18174",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3499",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3484",
  "quartz-webpack": "static-1.3431",
  "foundations-assets": "static-1.5006",
  "foundations-theming": "static-1.4564",
  "hub-http-shared-msw-handlers": "static-1.10290",
  "hubspotter-http": "static-1.4750",
  "sassPrefix": "static-1.158",
  "conversations-skeleton-state": "static-1.7379",
  "crm-message-bus": "static-1.43332",
  "customer-data-filters-ui-msw-helpers": "static-1.22691",
  "customer-data-objects-ui-components": "static-1.13161",
  "customer-data-reference-ui-components": "static-1.13307",
  "customer-data-ui-utilities": "static-1.9957",
  "events-data-lib": "static-1.366",
  "framework-builder-read-service-client": "static-1.4104",
  "framework-data-schema-quick-fetch": "static-1.6931",
  "framework-data-schema-resolvers": "static-1.7026",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3686",
  "inbound-db-properties-service-client": "static-1.3945",
  "multi-account-reference-resolvers": "static-1.1114",
  "onboarding-tours": "static-1.16854",
  "reporting-datasets-permissions-lib": "static-1.14058",
  "ui-addon-teams": "static-1.21722",
  "quartz-auth": "static-1.882",
  "ui-business-units-lib": "static-1.9201",
  "usage-tracker-session-replay": "static-1.5169",
  "ai-components-ui-library": "static-1.9283",
  "ContentUtils": "static-1.68750",
  "customer-data-properties": "static-1-sbelsky-fix-property-definition-memoization.2",
  "forms-ai-lib": "static-1.4526",
  "forms-utils-lib": "static-1.12832",
  "foundations-components-test-utils": "static-1.5677",
  "react-dnd-compat": "static-1.4746",
  "react-tinymce": "static-1.55592",
  "tinymce-config": "static-2.54718",
  "ui-gdpr-components": "static-1.10483",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3549",
  "HeadJS": "static-2.773",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3263",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.180",
  "ui-fonts": "static-1.865",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4457",
  "csstype": "static-1.50",
  "quartz-head": "static-1.872",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1676",
  "external-options-client-types": "static-1.4226",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.882",
  "frontend-preferences-client": "static-1.8059",
  "graphql": "static-1.83",
  "persist-promise": "static-1.3833",
  "reporting-client-types": "static-1.2578",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25765",
  "hubspot-apollo-client": "static-1.5010",
  "foundations-components-legacy": "static-1.1219",
  "quartz-routing": "static-1.637",
  "hs-story-utils": "static-1.9555",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.371",
  "timezone-utils": "static-2.5375",
  "seat-types-lib": "static-1.309",
  "react-create-root-preference": "static-1.39",
  "bend-plugin-foundations-components": "static-1.4463",
  "floating-ui": "static-1.58",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2216",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.848",
  "mobile-manifest-mixins": "static-1.547",
  "module-federation": "static-1.27",
  "quartz-test": "static-1.882",
  "quartz-tracking": "static-1.586",
  "trellis-components": "static-1.2235",
  "bend-plugin-chirp-manifest": "static-1.199",
  "chirp-fetch": "static-1.2020",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6115",
  "salesImages": "static-1.527",
  "ts-schema": "static-1.4181",
  "bender-build-tools": "static-1.3301",
  "calling-global-api": "static-1.64949",
  "calling-internal-common": "static-1.31444",
  "calling-lifecycle-internal": "static-1.66331",
  "calling-lifecycle-messages": "static-1.58625",
  "commerce-products-lib": "static-1.10055",
  "conditional-properties-service-client": "static-1.3897",
  "crm-links": "static-1.6440",
  "crm-pipelines-api-client-types": "static-1.4236",
  "customer-data-properties-shared-msw-handlers": "static-1.9617",
  "file-manager-components": "static-1.23994",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.309",
  "inbounddb-objects-service-types": "static-1.4317",
  "meetings-icalendar-utils-lib": "static-1.765",
  "multi-currency-client-types": "static-1.3790",
  "object-builder-ui-client": "static-1.49204",
  "pipeline-validation-client-types": "static-1.4065",
  "property-value-citations": "static-1-sbelsky-fix-property-definition-memoization.2",
  "pulse": "static-1.737",
  "smart-property-lib": "static-1.7931",
  "tiered-pricing": "static-1.1558",
  "ui-addon-iframeable": "static-1.9200",
  "user-context": "static-1.5240",
  "zustand": "static-1.74",
  "bend-plugin-foundations-theming": "static-1.3047",
  "stylex": "static-1.35",
  "restore-request-side-panel-lib": "static-1.1220",
  "react-immutable-render-mixin": "static-1.9",
  "fdsr-migration-layer": "static-1.145",
  "getting-started-shared-tasks": "static-1.18780",
  "growth-data-modal": "static-1.5646",
  "growth-onboarding-confetti": "static-1.3198",
  "growth-onboarding-next-action-utils": "static-1.2296",
  "navigation-components": "static-1.18323",
  "onboarding-tours-client": "static-1.5068",
  "onboarding-tours-utils": "static-1.920",
  "ui-shepherd-react": "static-3.10385",
  "ui-shepherd-tracker": "static-1.7766",
  "ui-universal-auth": "static-1.9137",
  "hubspotter-http-shared-msw-handlers": "static-1.10288",
  "magpie-lib": "static-1.5642",
  "navigation-messaging": "static-1.7650",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21917",
  "copilot-toolkit": "static-1.11473",
  "cms-field-types": "static-1.4947",
  "content-icons-ui": "static-1.2265",
  "integrations-lib": "static-1.16570",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.20059",
  "tinymce-themes": "static-1.56688",
  "data-token-picker": "static-1.16640",
  "hub-http-contrib": "static-1.3175",
  "interframe": "static-3.4891",
  "tinymce-data": "static-1.40803",
  "tinymce-plugins": "static-1.57832",
  "ui-addon-sales-email": "static-1.5342",
  "onboarding-scopes": "static-1.6592",
  "ui-addon-opt": "static-4.8494",
  "apollo-link-hub-http": "static-2.4783",
  "hubspot-apollo-cache": "static-1.469",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.306",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1075",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6118",
  "calling-error-reporting": "static-1.31451",
  "shared-worker-versioning": "static-1.11167",
  "calling-usage-tracker": "static-1.6676",
  "voice-sms-access-library": "static-1.1485",
  "customer-data-tracking": "static-1.7018",
  "commerce-permissions": "static-1.908",
  "products-iframe-lib": "static-1.8294",
  "products-ui-components-shared-msw-handlers": "static-1.10672",
  "location-customization-utils-lib": "static-1.9633",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1172",
  "immerable": "static-1.4282",
  "video-components-external": "static-1.11716",
  "video-data-lib": "static-1.35374",
  "event-emitter": "static-1.1082",
  "bend-plugin-pulse": "static-1.240",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.414",
  "feedback-loader": "static-1.29542",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10373",
  "fsm": "static-1.3863",
  "policy-lib": "static-1.6918",
  "react-colorpicker": "static-2.10339",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10436",
  "getting-started-shared-tasks-store": "static-1.17898",
  "onboarding-data-sync-lib": "static-1.2197",
  "growth-onboarding-next-action-components": "static-1.2324",
  "user-context-client": "static-1.4711",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5102",
  "nest": "static-1.364",
  "reactive-lib": "static-1.858",
  "simple-logging-lib": "static-1.3181",
  "unified-auth-core-lib": "static-1.933",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13985",
  "integrations-tracking-lib": "static-1.5739",
  "native-integrations-shared-strings": "static-1.7912",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10494",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.651",
  "FileManagerLib": "static-1.39634",
  "NamespacedHubStyle": "static-2.9153",
  "FileManagerCore": "static-1.39493",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7963",
  "layout-dnd-components": "static-1.12704",
  "layout-dnd-utils": "static-1.11679",
  "react-codemirror": "static-1.10760",
  "ui-addon-emoji-picker": "static-1.10018",
  "ui-brand-identity-lib": "static-1.15751",
  "calling-orchestration-schema": "static-1.36262",
  "sales-views-client-types": "static-1.4389",
  "crm-record-cards-service-types": "static-1.3684",
  "breeze-engine-core": "static-1.450",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "content-media-composition-data-lib": "static-1.12727",
  "content-media-compositions": "static-2.16734",
  "media-bridge-lib": "static-1.19156",
  "trellis-story-utils": "static-1.4642",
  "storybook-react": "static-1.34",
  "InboxConnectUtils": "static-4.15166",
  "meetings-connect-utils-lib": "static-1.7737",
  "universal-page-editor-lib": "static-1.3143",
  "adobe-sign-auth-lib": "static-1.61",
  "ads-unified-auth-lib": "static-1.479",
  "google-sheets-integration-lib": "static-1.624",
  "microsoft-drive-integration-lib": "static-1.781",
  "surveymonkey-integration-lib": "static-1.81",
  "slack-ui-library": "static-1.10529",
  "audio-components": "static-1.6119",
  "FileManagerImages": "static-1.37145",
  "video-components": "static-1.13718",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4667",
  "video-embed": "static-1.36208",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8837",
  "ui-coaching-tips": "static-1.28927",
  "ContentData": "static-1.68825",
  "layout-data-lib": "static-1.10004",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22395",
  "outpost": "static-1.4301",
  "growth-onboarding-feedback-components": "static-1.6711",
  "advanced-menus-core": "static-1.15347",
  "advanced-menus-lib": "static-1.12256",
  "ExportDialog": "static-6.10512",
  "ui-memberships-settings-lib": "static-1.34400",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15346",
  "simple-menus-lib": "static-1.16863"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34832",
  "atom": "/atom/static-1.5208",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2630",
  "client-types": "/client-types/static-1.484",
  "cssUtils": "/cssUtils/static-1.831",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40256",
  "customer-data-objects": "/customer-data-objects/static-1.7811",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8227",
  "documents-lib": "/documents-lib/static-1.34837",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.348",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86171",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4854",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2280",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5726",
  "hs-test-utils": "/hs-test-utils/static-1.8152",
  "hub-http": "/hub-http/static-1.6354",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11910",
  "HubStyleTokens": "/HubStyleTokens/static-2.11603",
  "I18n": "/I18n/static-7.1641",
  "icons": "/icons/static-2.656",
  "jasmine-immutable": "/jasmine-immutable/static-1.3154",
  "jasmine-runner": "/jasmine-runner/static-1.6590",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7284",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5529",
  "quartz": "/quartz/static-1.7207",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.81",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16817",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5441",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8308",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8228",
  "reporting-data": "/reporting-data/static-1.68090",
  "reporting-reports": "/reporting-reports/static-1.67768",
  "reporting-snowflake": "/reporting-snowflake/static-1.56708",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10023",
  "reporting-visualizations": "/reporting-visualizations/static-1.60166",
  "reselect": "/reselect/static-3.6",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9080",
  "sanitize": "/sanitize/static-1.4609",
  "sanitize-text": "/sanitize-text/static-1.8279",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1877",
  "signup-constants": "/signup-constants/static-1.19184",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8190",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "superstore": "/superstore/static-1.4892",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4892",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11123",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11207",
  "ui-images": "/ui-images/static-2.1189",
  "UIComponents": "/UIComponents/static-3.8549",
  "usage-tracker": "/usage-tracker/static-1.7483",
  "usage-tracker-container": "/usage-tracker-container/static-1.7473",
  "usage-tracker-core": "/usage-tracker-core/static-1.7333",
  "viral-links-lib": "/viral-links-lib/static-1.7202",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9793",
  "foundations-components": "/foundations-components/static-1.8194",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.985",
  "quartz-core": "/quartz-core/static-1.6426",
  "quick-fetch": "/quick-fetch/static-1.4017",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4789",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11281",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18174",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3499",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3484",
  "quartz-webpack": "/quartz-webpack/static-1.3431",
  "foundations-assets": "/foundations-assets/static-1.5006",
  "foundations-theming": "/foundations-theming/static-1.4564",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10290",
  "hubspotter-http": "/hubspotter-http/static-1.4750",
  "sassPrefix": "/sassPrefix/static-1.158",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7379",
  "crm-message-bus": "/crm-message-bus/static-1.43332",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22691",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13161",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13307",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9957",
  "events-data-lib": "/events-data-lib/static-1.366",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4104",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6931",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7026",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3686",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3945",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1114",
  "onboarding-tours": "/onboarding-tours/static-1.16854",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14058",
  "ui-addon-teams": "/ui-addon-teams/static-1.21722",
  "quartz-auth": "/quartz-auth/static-1.882",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9201",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5169",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9283",
  "ContentUtils": "/ContentUtils/static-1.68750",
  "customer-data-properties": "/customer-data-properties/static-1-sbelsky-fix-property-definition-memoization.2",
  "forms-ai-lib": "/forms-ai-lib/static-1.4526",
  "forms-utils-lib": "/forms-utils-lib/static-1.12832",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5677",
  "react-dnd-compat": "/react-dnd-compat/static-1.4746",
  "react-tinymce": "/react-tinymce/static-1.55592",
  "tinymce-config": "/tinymce-config/static-2.54718",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10483",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3549",
  "HeadJS": "/HeadJS/static-2.773",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3263",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.180",
  "ui-fonts": "/ui-fonts/static-1.865",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4457",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.872",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1676",
  "external-options-client-types": "/external-options-client-types/static-1.4226",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.882",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8059",
  "graphql": "/graphql/static-1.83",
  "persist-promise": "/persist-promise/static-1.3833",
  "reporting-client-types": "/reporting-client-types/static-1.2578",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25765",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5010",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1219",
  "quartz-routing": "/quartz-routing/static-1.637",
  "hs-story-utils": "/hs-story-utils/static-1.9555",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.371",
  "timezone-utils": "/timezone-utils/static-2.5375",
  "seat-types-lib": "/seat-types-lib/static-1.309",
  "react-create-root-preference": "/react-create-root-preference/static-1.39",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4463",
  "floating-ui": "/floating-ui/static-1.58",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2216",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.848",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.547",
  "module-federation": "/module-federation/static-1.27",
  "quartz-test": "/quartz-test/static-1.882",
  "quartz-tracking": "/quartz-tracking/static-1.586",
  "trellis-components": "/trellis-components/static-1.2235",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.199",
  "chirp-fetch": "/chirp-fetch/static-1.2020",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6115",
  "salesImages": "/salesImages/static-1.527",
  "ts-schema": "/ts-schema/static-1.4181",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "calling-global-api": "/calling-global-api/static-1.64949",
  "calling-internal-common": "/calling-internal-common/static-1.31444",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66331",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58625",
  "commerce-products-lib": "/commerce-products-lib/static-1.10055",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3897",
  "crm-links": "/crm-links/static-1.6440",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4236",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9617",
  "file-manager-components": "/file-manager-components/static-1.23994",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.309",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4317",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.765",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3790",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49204",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4065",
  "property-value-citations": "/property-value-citations/static-1-sbelsky-fix-property-definition-memoization.2",
  "pulse": "/pulse/static-1.737",
  "smart-property-lib": "/smart-property-lib/static-1.7931",
  "tiered-pricing": "/tiered-pricing/static-1.1558",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9200",
  "user-context": "/user-context/static-1.5240",
  "zustand": "/zustand/static-1.74",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3047",
  "stylex": "/stylex/static-1.35",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1220",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.145",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18780",
  "growth-data-modal": "/growth-data-modal/static-1.5646",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3198",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2296",
  "navigation-components": "/navigation-components/static-1.18323",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5068",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.920",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10385",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7766",
  "ui-universal-auth": "/ui-universal-auth/static-1.9137",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10288",
  "magpie-lib": "/magpie-lib/static-1.5642",
  "navigation-messaging": "/navigation-messaging/static-1.7650",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21917",
  "copilot-toolkit": "/copilot-toolkit/static-1.11473",
  "cms-field-types": "/cms-field-types/static-1.4947",
  "content-icons-ui": "/content-icons-ui/static-1.2265",
  "integrations-lib": "/integrations-lib/static-1.16570",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.20059",
  "tinymce-themes": "/tinymce-themes/static-1.56688",
  "data-token-picker": "/data-token-picker/static-1.16640",
  "hub-http-contrib": "/hub-http-contrib/static-1.3175",
  "interframe": "/interframe/static-3.4891",
  "tinymce-data": "/tinymce-data/static-1.40803",
  "tinymce-plugins": "/tinymce-plugins/static-1.57832",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5342",
  "onboarding-scopes": "/onboarding-scopes/static-1.6592",
  "ui-addon-opt": "/ui-addon-opt/static-4.8494",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4783",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.469",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.306",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1075",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6118",
  "calling-error-reporting": "/calling-error-reporting/static-1.31451",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11167",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6676",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1485",
  "customer-data-tracking": "/customer-data-tracking/static-1.7018",
  "commerce-permissions": "/commerce-permissions/static-1.908",
  "products-iframe-lib": "/products-iframe-lib/static-1.8294",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10672",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9633",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1172",
  "immerable": "/immerable/static-1.4282",
  "video-components-external": "/video-components-external/static-1.11716",
  "video-data-lib": "/video-data-lib/static-1.35374",
  "event-emitter": "/event-emitter/static-1.1082",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.240",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.414",
  "feedback-loader": "/feedback-loader/static-1.29542",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10373",
  "fsm": "/fsm/static-1.3863",
  "policy-lib": "/policy-lib/static-1.6918",
  "react-colorpicker": "/react-colorpicker/static-2.10339",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10436",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17898",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2197",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2324",
  "user-context-client": "/user-context-client/static-1.4711",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5102",
  "nest": "/nest/static-1.364",
  "reactive-lib": "/reactive-lib/static-1.858",
  "simple-logging-lib": "/simple-logging-lib/static-1.3181",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.933",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13985",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5739",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7912",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10494",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.651",
  "FileManagerLib": "/FileManagerLib/static-1.39634",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9153",
  "FileManagerCore": "/FileManagerCore/static-1.39493",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7963",
  "layout-dnd-components": "/layout-dnd-components/static-1.12704",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11679",
  "react-codemirror": "/react-codemirror/static-1.10760",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10018",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15751",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36262",
  "sales-views-client-types": "/sales-views-client-types/static-1.4389",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3684",
  "breeze-engine-core": "/breeze-engine-core/static-1.450",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12727",
  "content-media-compositions": "/content-media-compositions/static-2.16734",
  "media-bridge-lib": "/media-bridge-lib/static-1.19156",
  "trellis-story-utils": "/trellis-story-utils/static-1.4642",
  "storybook-react": "/storybook-react/static-1.34",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15166",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7737",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3143",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.61",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.479",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.624",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.781",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.81",
  "slack-ui-library": "/slack-ui-library/static-1.10529",
  "audio-components": "/audio-components/static-1.6119",
  "FileManagerImages": "/FileManagerImages/static-1.37145",
  "video-components": "/video-components/static-1.13718",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4667",
  "video-embed": "/video-embed/static-1.36208",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8837",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28927",
  "ContentData": "/ContentData/static-1.68825",
  "layout-data-lib": "/layout-data-lib/static-1.10004",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22395",
  "outpost": "/outpost/static-1.4301",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6711",
  "advanced-menus-core": "/advanced-menus-core/static-1.15347",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12256",
  "ExportDialog": "/ExportDialog/static-6.10512",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34400",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15346",
  "simple-menus-lib": "/simple-menus-lib/static-1.16863"
}
};
